import React from "react";
import { Container, Divider, Grid, Icon, List } from "semantic-ui-react";
import Helmet from "react-helmet";

import boote from "../../static/converted/waller_welt_boote-min.jpg";
import bruecke from "../../static/converted/waller_welt_bruecken-min.jpg";
import essen from "../../static/converted/waller_welt_essen-min.jpg";
import essen_2 from "../../static/converted/waller_welt_essen_2-min.jpg";
import kran from "../../static/converted/waller_welt_kran-min.jpg";
import kuehl from "../../static/converted/waller_welt_kuehl-min.jpg";
import luft from "../../static/converted/waller_welt_luft-min.jpg";
import park from "../../static/converted/waller_welt_park-min.jpg";
import schlauch from "../../static/converted/waller_welt_schlauch-min.jpg";
import steg from "../../static/converted/waller_welt_steg-min.jpg";
import steine from "../../static/converted/waller_welt_steine-min.jpg";
import tackle from "../../static/converted/waller_welt_tackle-min.jpg";

import Imgmodal from "../imgmodal";

const Mittellauf = () => {
  const schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      sameAs: [
        "https://www.facebook.com/Wallerwelt-by-Markus-Eule-296950883708594/"
      ],
      address: {
        "@type": "PostalAddress",
        addressLocality: "Borgoforte, Italien",
        postalCode: "IT-46030",
        streetAddress: "Via Al Ponte 1"
      },
      email: "info(at)wallerwelt.com",
      alumni: [
        {
          "@type": "Person",
          name: "Markus Eule"
        }
      ],
      member: [
        {
          "@type": "Organization"
        }
      ],
      name: "Waller-Welt (Waller-Welt.com)",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+39-345-997-3997",
          contactType: "customer service"
        }
      ]
    }
  ];
  return (
    <Container id="Mittellauf" className="main_content">
      <Helmet>
        {/* Schema.org tags */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
      </Helmet>

      <Grid verticalAlign="middle">
        <Grid.Column width={3} textAlign="right">
          <a
            href="https://www.facebook.com/Wallerwelt-by-Markus-Eule-296950883708594/"
            target="_blank"
          >
            <Icon size="huge" name="facebook" />
          </a>
        </Grid.Column>
        <Grid.Column width={13}>
          <h1>Waller-Welt am Po-Mittellauf</h1>
        </Grid.Column>
      </Grid>
      <br />
      <div className="responsive_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2818.8921708090616!2d10.75192131594015!3d45.04740997909816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47802ba29c016201%3A0x649636918685d6e8!2sWaller-+Welt+SRL!5e0!3m2!1sde!2sde!4v1523632399876"
          width="300"
          height="600"
          frameBorder="0"
          allowFullScreen
        />
      </div>
      <br />
      <br />
      <div className="responsive_map">
        <iframe
          type="text/html"
          frameborder="0"
          width="480"
          height="394"
          src="//video.nest.com/embedded/live/m0GAKWjBI9?autoplay=1"
          allowfullscreen
        ></iframe>
      </div>
      <Divider hidden />

      <Grid centered columns={2} stackable>
        <Grid.Column>
          <List>
            <List.Item>
              <Imgmodal img={park} />
              <p>
                Unser Parkplatz ist alarmgesichert und bietet genügend Platz für
                Autos, Wohnwägen und Trailer.
              </p>
            </List.Item>
            <List.Item>
              <Imgmodal img={bruecke} />
              <p>Das beste Revier am Mittellauf, vor der Haustüre.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={essen_2} />
              <p>
                Das Restaurant dient als Treffpunkt. Hier findet der
                Erfahrungsaustausch früh/mittags und abends statt.
              </p>
            </List.Item>
            <List.Item>
              <Imgmodal img={kuehl} />
              <p>Pro Boot steht immer ein Kühlschrank zur Verfügung.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={tackle} />
              <p>Angel-Komplettpaket? Kein Problem!</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={schlauch} />
              <p>Pro Boot ist immer ein Beiboot einsatzbereit.</p>
            </List.Item>
          </List>
        </Grid.Column>
        <Grid.Column>
          <List>
            <List.Item>
              <Imgmodal img={luft} />
              <p>Kurze Laufwege, direkt am Wasser.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={essen} />
              <p>Die Cocktails in der Bar sorgen für chillige Stimmung.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={kran} />
              <p>
                Die Krahnanlage ermöglicht das Beladen der Boote direkt aus dem
                Auto heraus.
              </p>
            </List.Item>
            <List.Item>
              <Imgmodal img={steine} />
              <p>Steine für Steinmontagen sind immer vorrätig.</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={steg} />
              <p>Große Steganlage mit Köderfischbecken,</p>
            </List.Item>
            <List.Item>
              <Imgmodal img={boote} />
              <p>
                Unsere Flotte: 6 Leihboote in Borgoforte 3 Leihboote in WW 2.0 -
                2 Flusstour Boote - 2 Guidingboote - 1 Reserveboot
              </p>
            </List.Item>
          </List>
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default Mittellauf;



// WEBPACK FOOTER //
// ./src/components/Mittellauf/index.js